import { __assign, __rest } from "tslib";
import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { deviationSchema, deviationExtendedSchema, } from '../normalizr/schemas/deviation';
import { getDataEntities, getDataEntityById, getDataEntitiesByIds, } from '../entities';
import { getUserById } from '../users/selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { getDeviationType, isDeviationAuthor, } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import DeviationMediaService from '../../utils/DeviationMediaService';
import { userSchema } from '../normalizr/schemas/user';
export var getNormalizedDeviationById = function (state, entityId) {
    return getDataEntityById(state, deviationSchema, entityId);
};
var getNormalizedDeviationsByIds = function (state, entityIds) {
    return getDataEntitiesByIds(state, deviationSchema, entityIds);
};
var getDeviationAuthorsByDeviationIds = function (state, entityIds) {
    var authorIds = getNormalizedDeviationsByIds(state, entityIds)
        .map(function (deviation) { return deviation.author; })
        .filter(function (authorId) { return !!authorId; });
    return getDataEntitiesByIds(state, userSchema, authorIds);
};
var getDeviationAuthorByDeviationId = function (state, entityId) {
    var deviation = getNormalizedDeviationById(state, entityId);
    if (!deviation) {
        return;
    }
    return getUserById(state, deviation.author);
};
var getDeviationGroupDestinationsByDeviationIds = function (state, entityIds) {
    var groupDestinationIds = getNormalizedDeviationsByIds(state, entityIds)
        .map(function (deviation) { return deviation.groupDestination; })
        .filter(function (groupDestinationId) { return !!groupDestinationId; });
    return getDataEntitiesByIds(state, userSchema, groupDestinationIds);
};
var getDeviationGroupDestinationByDeviationId = function (state, entityId) {
    var deviation = getNormalizedDeviationById(state, entityId);
    if (!deviation) {
        return;
    }
    return getUserById(state, deviation.groupDestination);
};
export var getHasCommentedOnDeviation = function (state, deviation) {
    if (!deviation.deviationId) {
        return false;
    }
    var normalizedDeviation = getNormalizedDeviationById(state, deviation.deviationId);
    return normalizedDeviation
        ? normalizedDeviation.hasCommentedOn
        : deviation.hasCommentedOn;
};
export var createGetDeviationById = function () {
    return createSelector([
        getNormalizedDeviationById,
        getDeviationAuthorByDeviationId,
        getDeviationGroupDestinationByDeviationId,
    ], function (deviation, author, groupDestination) {
        if (!deviation) {
            return undefined;
        }
        return __assign(__assign({}, deviation), { author: author, groupDestination: groupDestination, extended: undefined });
    });
};
// a default instance - prefer the selector creator for proper memoization
export var getDeviationById = createGetDeviationById();
export var getExtendedDeviationById = createSelector([function (state, entityId) { return entityId; }, getDeviationById, getDataEntities], function (entityId, deviation, entities) {
    if (!deviation || !entities[deviationExtendedSchema.key]) {
        return deviation;
    }
    // extended has a ton of stuff inside, needs to be denormalized
    deviation.extended = denormalize(entityId, deviationExtendedSchema, entities);
    return deviation;
});
export var createGetDeviationsByIds = function () {
    return createSelector(getNormalizedDeviationsByIds, getDeviationAuthorsByDeviationIds, getDeviationGroupDestinationsByDeviationIds, function (deviations, authors, groupDestinations) {
        return deviations.map(function (deviation) { return (__assign(__assign({}, deviation), { author: authors.find(function (author) { return author.userId === deviation.author; }), groupDestination: groupDestinations.find(function (groupDestination) {
                return groupDestination.userId === deviation.groupDestination;
            }), extended: undefined })); });
    });
};
// a default instance - prefer the selector creator for proper memoization
export var getDeviationsByIds = createGetDeviationsByIds();
export var getIsGif = function (deviation) {
    return DeviationMediaService.isGif(deviation);
};
export function getIsCurrentUserAuthorOf(state, deviation) {
    var user = getCurrentUser(state);
    return user ? isDeviationAuthor(deviation, user) : false;
}
export function getDeviationEditUrl(_a) {
    var extended = _a.extended, deviation = __rest(_a, ["extended"]);
    var deviationType = getDeviationType(deviation);
    // some types never go to edit page
    if ([
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
        DeviationTypes.TIER,
    ].includes(deviationType)) {
        return;
    }
    if (deviation.legacyTextEditUrl) {
        return deviation.legacyTextEditUrl;
    }
    // non-legacy journals/lit don't go to edit page
    if (![DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(deviationType)) {
        return extended && extended.editUrl;
    }
}
export function getDeviationIdFromNormalizedId(state, normalizedId) {
    var deviation = getNormalizedDeviationById(state, normalizedId);
    return (deviation && deviation.deviationId) || normalizedId;
}
//# sourceMappingURL=selectors.js.map